<template>
	<div class="uk-flex uk-flex-column uk-height-1-1">
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<template v-if="this.roles.is_staff">
					<span class="uk-navbar-item uk-logo">他店舗状況照会</span>
				</template>
				<template v-else>
					<span class="uk-navbar-item uk-logo">店舗状況照会</span>
				</template>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="navbar-item">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<div class="navbar-item uk-margin-right">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="returnButton">戻る</button>
				</div>
				<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>

		<div class="uk-grid-small uk-grid-match uk-margin-remove-left uk-margin-remove-right uk-height-1-1 uk-overflow-hidden" style="flex-grow: 1;" uk-grid="masonry: true">
			<div class="uk-height-1-1" style="width: 350px;" uk-overflow-auto>
				<div class="uk-display-inline">
					<div class="uk-margin-small-bottom">
						<label class="uk-form-label" for="create_form_job_type_name">対象日</label>
						<div class="uk-form-controls uk-width-small">
							<el-date-picker 
								id="el_datepicker" 
								v-model="params.target_date_picker" 
								format="yyyy/MM/dd" 
								:type="date" 
								:editable="false" 
								:clearable="false" 
								:picker-options="date_picker_options" 
								placeholder="YYYY/MM/DD">
							</el-date-picker>
						</div>
					</div>

					<div class="uk-margin-small-bottom">
						<label class="uk-form-label" for="create_form_start">開始時間</label>
						<div class="uk-form-controls uk-width-medium">
							<div class="uk-grid-small uk-child-width-auto uk-grid">
								<div class="uk-width-1-2">
									<el-time-select
											placeholder="start time"
										v-model="params.start_time_picker"
										:editable="false"
										:picker-options="{
										start: '07:00',
										step: '01:00',
										end: '21:00'
										}"
										@change="changeEndTime">
									</el-time-select>
								</div>
								<div class="uk-width-1-2">
									<el-time-select
											placeholder="End time"
										v-model="params.end_time_picker"
										:editable="false"
										:picker-options="{
										start: '08:00',
										step: '01:00',
										end: '22:00',
										minTime: params.start_time_picker
										}">
									</el-time-select>
								</div>
							</div>
						</div>
					</div>

					<div class="uk-margin-small-bottom">
						<label class="uk-form-label" for="create_form_job_type_name">所要時間&nbsp;<span style="font-size: 0.8em;">※選択した時間以上の空き枠を表示します</span></label>
						<div class="uk-form-controls uk-width-small">
							<select id="create_form_job_type_name" class="uk-select" name="job_type" v-model="params.required_time">
								<option value="15">15分</option>
								<option value="30">30分</option>
								<option value="45">45分</option>
								<option value="60">60分</option>
								<option value="90">90分</option>
								<option value="120">120分</option>
							</select>
						</div>
					</div>
					<div class="uk-margin-small-bottom">
						<label class="uk-form-label" for="create_form_job_type_name">部</label>
						<div class="uk-form-controls">
							<div class="uk-overflow-auto" style="height: 150px; border: solid 1px #DDD">
								<ul class="uk-list uk-list-collapse">
									<li>
										<label class="uk-display-block uk-width-1-1">
											<input class="uk-checkbox" type="checkbox" v-model="selectAllDivision">全選択／全解除
										</label>
									</li>
									<template v-for="(division, index) in all_division">
										<li class="uk-margin-remove" :key="index">
											<label class="uk-display-block uk-width-1-1"><input class="uk-checkbox" name="division" type="checkbox" :value="division.division_code" v-model="params.checkedDivisions">{{ division.division_name }}</label>
										</li>
									</template>
								</ul>
							</div>
						</div>
					</div>
					<div class="uk-margin-small-bottom">
						<label class="uk-form-label" for="create_form_job_type_name">業務名（スキル名）</label>
						<div class="uk-form-controls">
							<div class="uk-overflow-auto" style="height: 300px; border: solid 1px #DDD">
								<ul class="uk-list uk-list-collapse">
									<li>
										<label class="uk-display-block uk-width-1-1">
											<input class="uk-checkbox" type="checkbox" v-model="selectAllSkill">全選択／全解除
										</label>
									</li>
									<template v-for="(skill_attribute, index) in skill_attributes">
										<li class="uk-margin-remove" :key="index">
											<label class="uk-display-block uk-width-1-1">
												<input class="uk-checkbox" type="checkbox" :value="skill_attribute.id" v-model="params.checkedSkill">{{ skill_attribute.name }}
											</label>
										</li>
									</template>
								</ul>
							</div>
						</div>
					</div>
					<div class="uk-margin-small">
						<button class="uk-button uk-button-primary uk-align-center uk-button-large uk-margin-remove-bottom" @click="search" :disabled="isDisabled">検索</button>
					</div>
				</div>
			</div>

			<div class="uk-width-expand uk-height-1-1">
				<div class="uk-height-1-1" style="overflow-y: scroll;">
					<table id="shop_table" class="uk-table uk-table-expand uk-table-striped uk-margin-bottom table_style">
						<colgroup>
							<col style="width: 350px;">
							<col span="2" style="width: 80px;">
							<col span="2" style="width: 160px;">
							<col span="3" style="width: 120px;">
						</colgroup>
						<thead>
						<tr>
							<th>店舗名</th>
							<th>開始時間</th>
							<th>終了時間</th>
							<th>連絡先（裏番）</th>
							<th>連絡先（その他）</th>
							<th colspan="3">クリックでリモート接続 or 右クリックでリンクコピー</th>
						</tr>
						</thead>
						<tbody>
						<template v-for="(reservation, index) in shop_reservations">
							<tr class="data_row" :key="index">
								<td>{{ reservation.name }}</td>
								<td>{{ reservation.plan_start_time | moment }}</td>
								<td>{{ reservation.plan_end_time | moment }}</td>
								<td>{{ reservation.secret_number_1 }}</td>
								<td>{{ reservation.secret_number_2 }}</td>
								<td>
									<template v-if="reservation.remote_number_1 !== null">
										<a :href="reservation.remote_number_1" target="_blank">リモート①</a>
									</template>
								</td>
								<td>
									<template v-if="reservation.remote_number_2 !== null">
										<a :href="reservation.remote_number_2" target="_blank">リモート②</a>
									</template>
								</td>
								<td>
									<template v-if="reservation.remote_number_3 !== null">
										<a :href="reservation.remote_number_3" target="_blank">リモート③</a>
									</template>
								</td>
							</tr>
						</template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<!--/ Main -->
	</div>
</template>

<script>
	import StaffAuth from '@/api/StaffAuth'
	import SkillAttribute from '@/api/SkillAttribute'
	import Shop from '@/api/Shop'
	import ShopReservation from '@/api/ShopReservation'
	import Role from '@/api/Role'

	const max_time = '22:00'

	export default {
		name: 'ShopAnotherSearchPage',
		components: {},
		comments: [],
		data () {
			return {
				// 検索パラメータ
				params: {
					// 対象日
					target_date_picker: moment().format('YYYY/MM/DD'),
					// 開始時間
					start_time_picker: moment().startOf('hour').format('HH:mm'),
					// 終了時間
					end_time_picker: moment().startOf('hour').add(3, 'h').format('HH:mm'),
					// 所要時間
					required_time: '15',
					// 部
					checkedDivisions: [],
					// 業務名（スキル名）
					checkedSkill: []
				},
				isDisabled: false,
				skill_attributes: [],
				shop_reservations: [],
				all_division: [],
				roles: [],
				current_staff: null,
				shop_id: null,
				date_picker_options: {
					format: 'yyyy/MM/dd'
				}
			}
		},
		filters: {
			moment: function (date) {
				return moment(date, 'HH:mm').format('HH:mm')
			}
		},
		computed: {
			/**
			 * 部の全選択／全解除
			 */
			selectAllDivision: {
				get: function () {
					return this.params.checkedDivisions.length == this.all_division.length
				},
				set: function (checked) {
					this.params.checkedDivisions = checked ? this.all_division.map((row) => { return row.division_code }) : []
				}
			},
			/**
			 * スキルの全選択／全解除
			 */
			selectAllSkill: {
				get: function () {
					return this.params.checkedSkill.length == this.skill_attributes.length
				},
				set: function (checked) {
					this.params.checkedSkill = checked ? this.skill_attributes.map((row) => { return row.id }) : []
				}
			}
		},
		methods: {
			/**
			 * 戻るボタン押下時
			 */
			returnButton () {
				if (this.roles.is_call_center) {
					this.$router.push('/shop_search')
				} else {
					this.$router.push('/reservation_list/' + this.current_staff.shop_id)
				}

				location.reload()
			},
			/**
			 * ログアウトボタン押下時
			 */
			clickLogoutButton () {
				let self = this

				Role.show().then(function (response) {
					let role_ = response.data.data

					let return_url = '/'

					if (role_.is_call_center) {
						return_url = '/call_center/login'
					}

					StaffAuth.logout().then(function (response) {
						self.$router.push(return_url)
						location.reload()
					})
				})
			},
			changeEndTime () {
				let self = this

				if (self.params.start_time_picker >= self.params.end_time_picker) {
					self.params.end_time_picker = moment(self.params.start_time_picker, 'HH:mm').startOf('hour').add(1, 'h').format('HH:mm')
				}
			},
			loadDivision () {
				let self = this

				Shop.all_division().then(function (response) {
					self.all_division = response.data.data
				})
			},
			loadCurrentStaff () {
				let self = this

				StaffAuth.current().then(function (response) {
					self.current_staff = response.data.data

					if (self.roles.is_staff) {
						// ログインユーザーの「部コード」取得
						self.params.checkedDivisions.push(self.current_staff.shop.division_code)
					}
				})
			},
			loadRoles () {
				let self = this

				Role.show().then(function (response) {
					self.roles = response.data.data
				})
			},
			loadSkillAttributes () {
				let self = this
				let params = new URLSearchParams()
				params.append('status', 0)

				SkillAttribute.all(params).then(function (response) {
					self.skill_attributes = response.data.data
				})
			},
			search () {
				let self = this

				self.isDisabled = true

				// 一覧クリアー
				self.shop_reservations.splice(0, self.shop_reservations.length)

				// 検索パラメータ
				let params = new URLSearchParams()

				// ログインユーザーが「スタッフ」の場合
				if (self.roles.is_staff) {
					// 自身店舗を除外する
					params.append('not_match_shop_code', self.current_staff.shop_id)
				}

				// 対象日
				params.append('date', moment(self.params.target_date_picker).format('YYYY-MM-DD'))

				// 開始時間
				params.append('start_time', self.params.start_time_picker)

				// 終了時間
				params.append('end_time', self.params.end_time_picker)

				// 所要時間
				params.append('required_time', self.params.required_time)

				// 部
				// console.log('部 > ' + self.params.checkedDivisions.length)
				if (self.params.checkedDivisions.length > 0) {
				// console.log('部 >>> ')
					params.append('divisions', self.params.checkedDivisions)
				}

				// 業務名（スキル名）
				// console.log('スキル > ' + self.params.checkedSkill.length)
				if (self.params.checkedSkill.length > 0) {
				// console.log('スキル >>> ')
					params.append('skill', self.params.checkedSkill)
				}

				ShopReservation.searchUnoccupied(params).then(function (response) {
					self.shop_reservations = response.data.data

					// 空き枠データが存在しない場合
					if (self.shop_reservations.length == 0) {
						alert('該当データが存在しません')
					}
				}).finally(function () {
					self.isDisabled = false
				})
			}
		},
		created () {
			this.loadRoles() // 権限チェック
			this.loadCurrentStaff()
			this.loadSkillAttributes()
			this.loadDivision()

			if (max_time < this.params.end_time_picker) {
				this.params.end_time_picker = moment(max_time, 'HH:mm').format('HH:mm')
			}
		},
		beforeMount () {
		},
		mounted () {
			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data
			})
		},
		beforeRouteLeave (to, from, next) {
			$('.uk-open').remove()
			next()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	// #shop_table {
	.table_style {
		border-collapse: separate;

		thead {
			tr {
				th {
					position: -webkit-sticky;
					position: sticky;
					top: 0;
					z-index: 1;
					border: solid 1px #DDD;
					text-align: center;
					text-transform: none;
					vertical-align: middle;
					white-space: nowrap;
					background: lightcyan;
				}
			}
		}

		tbody {
			tr {
				td {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
					white-space: nowrap;
				}
			}
		}

		.data_row_before_save {
			background: #FFFDE6;
		}
	}
</style>
<style lang="scss">
	html {
		height: 100%;
	}

	body {
		height: 100%;
		margin: 0;
	}

	#app {
		height: 100%;
	}

	.uk-modal-page {
		height: auto;
	}

	.vdp-datepicker {
		z-index: 999;
	}

	.time-picker {
		width: 100% !important;

		input {
			width: 100% !important;
		}
	}

	.el-date-editor {
		width: 100% !important;
	}
	.el-input__inner {
		border-radius: 0;
	}

</style>



// WEBPACK FOOTER //
// src/components/page/ShopAnotherSearchPage.vue